// Generated by CoffeeScript 1.12.7
define('views/components/theme_builder',['require','underscore','tinycolor','text!templates/theme.css','etc/definitions','web_font_loader'],function(require) {
  var ThemeBuilder, WebFont, _, logo, stylesTemplate, tinycolor;
  _ = require('underscore');
  tinycolor = require('tinycolor');
  stylesTemplate = require('text!templates/theme.css');
  logo = require('etc/definitions').logo;
  WebFont = require('web_font_loader');
  return ThemeBuilder = (function() {
    ThemeBuilder.THEME_ID = 'theme-styles';

    ThemeBuilder.CUSTOM_THEME_ID = 'custom-theme-styles';

    ThemeBuilder.prototype.theme = null;

    function ThemeBuilder(options) {
      if (options != null) {
        this.theme = options.theme;
      }
    }

    ThemeBuilder.prototype.render = function(callback) {
      this.removeTheme();
      if (_.isEmpty(this.theme)) {
        this.setHeaderLogo();
        return callback();
      }
      if (this.theme.link && this.theme.link.length) {
        return this.loadLinkedStyles(callback);
      } else if (!_.isEmpty(this.theme.styles)) {
        this.loadStyles();
        return callback();
      } else {
        return callback();
      }
    };


    /**
    		Load theme styles
    
    		@method loadStyles
     */

    ThemeBuilder.prototype.loadStyles = function() {
      var $styles, styles;
      this.loadThemeFonts();
      _.mixin({
        tinycolor: tinycolor,
        overlayImage: this.overlayImage
      });
      styles = _.template(stylesTemplate)(this.theme.styles).replace(/(\r\n|\n|\r|\t)/gm, "").replace(/\/\*(\*(?!\/)|[^*])*\*\//gm, "");
      $styles = $('<style>').attr({
        type: 'text/css',
        id: ThemeBuilder.THEME_ID
      }).text(_.escape(styles)).appendTo('head');
      this.loadCustomStyles();
      return this.setHeaderLogo();
    };


    /**
    		Load premade theme from url
    
    		@method loadLinkedStyles
     */

    ThemeBuilder.prototype.loadLinkedStyles = function(callback) {
      var $link, loaded;
      loaded = false;
      $link = $("<link>").attr({
        href: this.theme.link,
        id: ThemeBuilder.THEME_ID,
        rel: 'stylesheet',
        type: 'text/css'
      });
      $link.load((function(_this) {
        return function() {
          if (!loaded) {
            loaded = true;
            _this.loadCustomStyles();
            return setTimeout(function() {
              _this.setHeaderLogo();
              return callback();
            }, 0);
          }
        };
      })(this));
      return $link.appendTo('head');
    };


    /**
    		Load custom CSS
    
    		@method loadCustomStyles
     */

    ThemeBuilder.prototype.loadCustomStyles = function() {
      if (this.theme && this.theme.styles && this.theme.styles.custom && this.theme.styles.custom.length) {
        return $('<style>').attr({
          type: 'text/css',
          id: ThemeBuilder.CUSTOM_THEME_ID
        }).text(_.escape(this.theme.styles.custom)).appendTo('head');
      }
    };


    /**
    		Checks the background color of the header bar and changes the logo for best contrast.
    
    		@method setHeaderLogo
     */

    ThemeBuilder.prototype.setHeaderLogo = function() {
      var $header, $img, $logo, bgColor, bgLuminance, color, defaultLogo, imgSource, luminanceVariance, spGreenLuminance;
      $header = $('#survey-header');
      $logo = $header.find('#header-logo');
      $img = $logo.find('img');
      imgSource = $img.attr('src');
      if (imgSource === logo.light || imgSource === logo.dark || imgSource === logo.white || imgSource === logo.black) {
        spGreenLuminance = .44;
        luminanceVariance = .13;
        defaultLogo = logo.dark;
        bgColor = $header.css("background-color");
        color = tinycolor(bgColor);
        bgLuminance = color.getLuminance();
        if (bgLuminance < .5) {
          defaultLogo = logo.light;
        } else {
          defaultLogo = logo.dark;
        }
        if ((spGreenLuminance - luminanceVariance < bgLuminance && bgLuminance < spGreenLuminance + luminanceVariance)) {
          defaultLogo = logo.white;
        }
        $img.attr('src', defaultLogo);
        $("#welcome-header img").attr('src', defaultLogo);
      }
      return $logo.animate({
        opacity: 1
      });
    };


    /**
    		Removes all the theme styles from the head of the document.
    
    		@method removeTheme
    		@return {Object} theme styles that were removed
     */

    ThemeBuilder.prototype.removeTheme = function() {
      $('head').find("#" + ThemeBuilder.THEME_ID).remove();
      return $('head').find("#" + ThemeBuilder.CUSTOM_THEME_ID).remove();
    };


    /**
    		Adds google font to the head of the document
    
    		@method loadThemeFont
    		@param {Function} callback callback function
    		@async
    		@return {Object}
     */

    ThemeBuilder.prototype.loadThemeFonts = function() {
      var fonts;
      if (!_.isEmpty(this.theme.styles)) {
        fonts = _.chain(this.theme.styles).map('font').reject(function(item) {
          return _.isUndefined(item) || _.isNull(item);
        }).uniq().value();
      }
      if (fonts && fonts.length) {
        return WebFont.load({
          google: {
            families: fonts
          }
        });
      }
    };

    ThemeBuilder.prototype.overlayImage = function(image, opacity, bgColor) {
      var color, filter, index;
      if ((image != null) && image.length) {
        image = image.replace("e_improve", "").replace(/\,?o_[0-9]{0,3}/, "");
        if ((opacity != null) && opacity < 100) {
          filter = "o_" + opacity;
          if (bgColor && !_.isEmpty(bgColor)) {
            color = tinycolor(bgColor).toHex();
            filter += ",b_rgb:" + color;
          }
          index = image.indexOf("/upload");
          if (index > -1) {
            return image.slice(0, index + 7) + "/" + filter + image.slice(index + 7);
          }
        } else {
          return image;
        }
      }
    };

    return ThemeBuilder;

  })();
});

